// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1f13g","tab":"ProcedureTabs_tab__MGKvg"};